/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SectionProviderAPI
 * @hideconstructor
 * @classdesc API class for a SectionProvider
 */
define([], () => {
	class SectionProviderAPI {
		/**
		 * @function SectionProviderAPI#getId
		 * @description get the unique section identifier
		 * @returns {String} unique identifier of the section
		 */
		getId() {}

		/**
		 * @function SectionProviderAPI#getLabel
		 * @description get the section display label
		 * @returns {String} display label of the section
		 */
		getLabel() {}

		/**
		 * @function SectionProviderAPI#render
		 * @description render the section
		 * @returns {React.Component}
		 */
		render() {}

		/**
		 * @function SectionProviderAPI#getEnabled
		 * @description determine the enable state of the section
		 * @returns {boolean} true if the section is enabled, otherwise false
		 */
		getEnabled() {}

		/**
		 * @function SectionProviderAPI#setContent
		 * @description set the active content to the section
		 * @param {ContentAPI} content current active content
		 */
		setContent() {}

		/**
		 * @function SectionProviderAPI#getToggleSupport
		 * @description determine whether the section supports a toggle on/off state
		 * @returns {boolean} true if the toggle state is supported, otherwise false
		 */
		getToggleSupport() {}

		/**
		 * @function SectionProviderAPI#getChecked
		 * @description get the on/off toggle state of the section
		 * @returns {boolean} true if the state is on, otherwise false
		 */
		getChecked() {}

		/**
		 * @function SectionProviderAPI#setChecked
		 * @description set the on/off toggle state of the section
		 * @param {boolean} checked true to turn on the state, otherwise false
		 */
		setChecked() {}

		/**
		 * @function SectionProviderAPI#on
		 * @description register API event handlers
		 */
		on(){}


		/**
		 * @function SectionProviderAPI#off
		 * @description deregister API event handlers
		 */
		off(){}

		/**
		 * @function SectionProviderAPI#getVisIconId
		 * @return A string identifying the visualization icon of the associated section.
		 */
		getVisIconId(){}

		/**
		 * @function SectionProviderAPI#onChange
		 * @param {boolean} opened state of the section. true if expanded, false otherwise
		 * @param {boolean} isExternalEvent true indicates the trigger of change is external to the section
		 * @description 
		 */
		onChange(){}

		/**
		 * @function SectionProviderAPI#getToggleTooltip
		 * @description Get the tooltip for the section toggle
		 * @returns {String} tooltip for the toggle in the current context
		 */
		getToggleTooltip() {}
	}

	return SectionProviderAPI;
});
